import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const CatalogFile = (props: SvgIconProps) => {
   const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 448 512"
      {...props}
    >
        <path
           opacity={0.1}
          d="M32 176l0 240c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-240c0-8.8-7.2-16-16-16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-128 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16 7.2-16 16z"
        />
        <path
          fill={props.htmlColor || theme.palette.secondary[500]}
          d="M160 96l0 32 128 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 64l-80 0c-8.8 0-16 7.2-16 16l0 240c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-240c0-8.8-7.2-16-16-16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-128 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80zm0-32l0-32c0-53 43-96 96-96s96 43 96 96l0 32 80 0c26.5 0 48 21.5 48 48l0 240c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 176c0-26.5 21.5-48 48-48l80 0z"
        />
    </SvgIcon>
  );
};
